import Icon from '../components/Icon.vue'

Icon.register({
  binoculars: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M416 48v48h-96v-48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16zM63.9 160c0.5-17.6 14.3-32 31.9-32h96.2v160h-32v160c0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32v-44c3.5-129.8 61.4-150.2 63.9-244zM448.1 160c2.5 93.8 60.5 114.2 63.9 244v44c0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32v-160h-32v-160h96.2c17.6 0 31.5 14.4 31.9 32zM176 32c8.8 0 16 7.2 16 16v48h-96v-48c0-8.8 7.2-16 16-16h64zM224 288v-160h64v160h-64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/binoculars.js
// module id = 665
// module chunks = 0